import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Login from '../login/page/Container'
import Forbidden403 from './../403'
import E404 from './../404/E404Container'
import Home from './../apps/Home/HomeContainer'
import PrivateRoute from './PrivateRoute'
import ScrollToTop from './ScrollToTop'

/*
* Lazy loading
*/
const Dokstor = React.lazy(() => import('../apps/dokstor/pages/DokstorContainer'))
const Admin = React.lazy(() => import('../apps/Admin/pages/AdminContainer'))
const SuperAdmin = React.lazy(() => import('../apps/SuperAdmin/pages/SuperAdminContainer'))
const ReferenceData = React.lazy(() => import('./../apps/referenceData/pages/ReferenceDataContainer'))
const CaseManagement = React.lazy(() => import('./../apps/caseManagement/pages/CaseManagementContainer'))


const RoboloticsRouter = () => {

    return (
        <Router>
            <>
                <ScrollToTop />
                <Switch>
                    <Route exact path="/">
                        <Login />
                    </Route>
                    <Route path="/admin">
                        <PrivateRoute>
                            <Admin />
                        </PrivateRoute>
                    </Route>
                    <Route path="/sysadmin">
                        <PrivateRoute>
                            <SuperAdmin />
                        </PrivateRoute>
                    </Route>
                    <Route exact path="/home">
                        <PrivateRoute>
                            <Home />
                        </PrivateRoute>
                    </Route>
                    <Route path="/dokstor">
                        <PrivateRoute>
                            <Dokstor />
                        </PrivateRoute>
                    </Route>
                    <Route path="/reference-data">
                        <PrivateRoute>
                            <ReferenceData />
                        </PrivateRoute>
                    </Route>
                    <Route path="/case-management">
                        <PrivateRoute>
                            <CaseManagement />
                        </PrivateRoute>
                    </Route>
                    <Route path="/forbidden">
                        <PrivateRoute>
                            <Forbidden403 />
                        </PrivateRoute>
                    </Route>
                    <Route>
                        <E404 />
                    </Route>
                </Switch>
            </>
        </Router>
    )
}


export default RoboloticsRouter